import { NgModule } from '@angular/core';
import { ListPaginatorComponent } from './list-paginator.component';
import { TextfieldComponent } from '../../form/textfield/textfield.component';

@NgModule({
    declarations: [
        ListPaginatorComponent
    ],
    imports: [
        TextfieldComponent,
    ],
    exports: [
        ListPaginatorComponent
    ]
})
export class ListPaginatorModule { }